<template>
<div class="row">
    <div class="col mb-4">
      <button type="button"
        class="btn u-mb-20"
        @click="$router.go(-1)"
      >
        <i class="fa fa-arrow-left"></i>
        &nbsp; Volver
      </button>
    </div>
    <div class="col-xs-12 col-md-12 col-lg-12">
        <card header-text="Subir acta o documento">
            <formio
                ref="loginFormio"
                :form="subirArchivoForm"
                :options="optionsFormio"
                @submit="onSubmit"
                @error="onError"
            >
            </formio>
            <bootstrap-progress-bar v-if="progreso" type="success" :width.sync="progreso"></bootstrap-progress-bar>
        </card>
      </div>
</div>

</template>

<script>
/* eslint-disable prefer-promise-reject-errors */
import subirArchivoForm from './formio/subirDocumento'
import { Form } from 'vue-formio'
import apiStorage from '../../api/storage'
import { obtenerInspiradorPorId, guardarDocumento } from '../../api/inspiradores'
import firebase from 'firebase'
import BootstrapProgressBar from '../../components/progressbar/BootstrapProgressBar'
import { mapState } from 'vuex'

export default {
  components: { formio: Form, BootstrapProgressBar },
  data () {
    return {
      inspirador: {},
      keyInspirador: '',
      cargando: false,
      progreso: 0
    }
  },
  computed: {
    ...mapState('user', [
      'token',
      'user'
    ]),
    subirArchivoForm () {
      return subirArchivoForm
    },
    optionsFormio () {
      return {
        noAlerts: true
      }
    },
    apiStorage () {
      return apiStorage
    }
  },
  async mounted () {
    // await this.loadInspirador(this.$route.params.id)
  },
  methods: {
    async onSubmit (submission) {
      const that = this
      const archivo = submission.data.archivo.pop()
      const documento = {
        dniUsuario: that.user.numeroIdentificacion,
        descripcion: submission.data.descripcion,
        fechaCreacion: firebase.firestore.Timestamp.fromDate(new Date()),
        nombre: archivo.originalName
      }

      const uploadTask = this.apiStorage.guardarDocumentoBase64(archivo, this.user.numeroIdentificacion)
      await new Promise((resolve, reject) => {
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          function (snapshot) {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            that.progreso = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)

            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                reject('Subida pausada')
                break
              case firebase.storage.TaskState.RUNNING: // or 'running'
                break
            }
          }, function (error) {
            switch (error.code) {
              case 'storage/unauthorized':
                reject('Subida sin autorización')
                break
              case 'storage/canceled':
                reject('Subida cancelada')
                break
              case 'storage/unknown':
                reject('Storage desconocido')
                break
              default:
                break
            }
          }, function () {
            guardarDocumento(documento).then(resp => {
              resolve()
            }).catch(err => {
              console.error(err)
            })
          })
      })

      this.$router.push({ name: 'documentos' })
    },
    onError (err) {
      console.error(err)
    },
    async loadInspirador (id) {
      const inspiradorDoc = await obtenerInspiradorPorId(id)
      this.inspirador = inspiradorDoc.data()
      this.keyInspirador = inspiradorDoc.id
    }
  }

}
</script>
